import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

AdminRouter.addRoute({
  name: `edit-company`,
  path: `/edit-company`,
  component: () => import('./Edit.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `edit-company`,
  text($vm) {
    return $vm.$t(`company.settings`)
  },
  route: {
    name: `edit-company`,
  },
  icon: 'icon-cog',
  permission($vm) {
    return !$vm.$allows('administer') && $vm.$account && !!$vm.$account.company
  },
})

messageGroups.push('company')
